import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Lottie from "lottie-react";
import notFoundAnimation from "../Animation - 1750415397609.json"; // Ensure the path is correct

const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-100 to-blue-100 dark:from-gray-900 dark:to-gray-800 px-6">
      <div className="text-center max-w-xl">
        <div className="w-full h-64 md:h-80 lg:h-96 mb-6">
          <Lottie
            animationData={notFoundAnimation}
            loop
            autoplay
            className="w-full h-full mx-auto"
          />
        </div>

        <h1 className="text-4xl font-extrabold text-gray-800 dark:text-white mb-2">
          404 - Page Not Found
        </h1>
        <p className="text-gray-600 dark:text-gray-300 mb-6 text-lg">
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl transition-all shadow-xl"
        >
          <ArrowLeft className="w-5 h-5" />
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
